import { useQuery } from "@tanstack/react-query";
import { ProvincesService } from "services/openapi";
import { ProvincesQueryKeys } from "./constants";

export const useGetAllDevisionsQuery = (variables?: {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [ProvincesQueryKeys.GET_ALL_DEVISIONS],
    queryFn: () => ProvincesService.provincesControllerGetAllDevisions(),
    enabled: variables?.enabled ?? true,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours - administrative divisions don't change often
    cacheTime: 24 * 60 * 60 * 1000, // 24 hours
    refetchOnWindowFocus: false,
  });
};
